export class VerificateModel {
  Rnc: string;
  RazonSocial: string;
  Codia: number;
  EsCodiaValido: boolean;
  PoseeContratoVigente: boolean;
  EstaRegistradoEnSorteo: boolean;
  EstaRegistradoEnMiPyme: boolean;
  EstaRegistradoEnDgii: boolean;
  EstaRegistradoEnCodia: boolean;
  EstaRegistradoComoEmpleadoMopc: boolean;
  ActivarDgii: boolean;
  DesactivarDgii: boolean;
  RegistrarDgii: boolean;
  ActivarCodia: boolean;
  DesactivarCodia: boolean;
  RegistrarCodia: boolean;
  ActivarMiPyme: boolean;
  DesactivarMiPyme: boolean;
  RegistrarMiPyme: boolean;
  ActivarEmpleadoMOPC: boolean;
  DesactivarEmpleadoMOPC: boolean;
  Email: string;
  CodigoRegistro: string;
  Dia: string;
  Hora: string;
  Estatus:string;
}
